import React, { useState, MouseEvent } from 'react';
import { motion } from 'framer-motion';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import Popover from '@mui/material/Popover';
import InsertEmoticonIcon from '@mui/icons-material/InsertEmoticon';
import { IEmojiData } from 'emoji-picker-react';

let EmojiPicker;
if (typeof window !== 'undefined') {
  import('emoji-picker-react').then((_module) => {
    EmojiPicker = _module.default;
  });
}

interface EmojiButtonProps {
  handleClickEmoji: (event: MouseEvent, emojiData: IEmojiData) => void;
}

const EmojiButton = ({ handleClickEmoji }: EmojiButtonProps) => {
  const [emojiBtnAnchorEl, setEmojiBtnAnchorEl] =
    useState<HTMLDivElement | null>(null);

  return (
    <>
      <motion.div
        whileTap={{ scale: 0.9 }}
        whileHover={{ scale: 1.05 }}
        onClick={(e) => setEmojiBtnAnchorEl(e.currentTarget)}
      >
        <Box id="icons-picker" sx={{ marginRight: '10px' }}>
          <Tooltip title="Add emoji" placement="top" enterDelay={1000}>
            <span>
              <IconButton
                disableRipple
                sx={{
                  p: 0,
                  color: Boolean(emojiBtnAnchorEl) ? 'primary.main' : '#5a5a5a',
                  '&:hover': { color: 'primary.main' },
                }}
                size="small"
              >
                <InsertEmoticonIcon />
              </IconButton>
            </span>
          </Tooltip>
        </Box>
      </motion.div>

      <Popover
        open={Boolean(emojiBtnAnchorEl)}
        anchorEl={emojiBtnAnchorEl}
        onClose={() => setEmojiBtnAnchorEl(null)}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <EmojiPicker
          preload
          disableSkinTonePicker
          onEmojiClick={handleClickEmoji}
        />
      </Popover>
    </>
  );
};

export default EmojiButton;
